export const phonePlaceholderInForm =
    'Please enter 4 - 15 digits and do not start with 0';

export const reformatPhone = (items) => {
    return items.map((item) => ({
        ...item,
        Phone: (item.Phone && item.Phone.replace('+', '')) || '',
    }));
};
